import { mapEnumToOptions } from '@abp/ng.core';

export enum ReportType {
  Native = 0,
  PowerBi = 1,
}

export const reportTypeOptions = mapEnumToOptions(ReportType);
